import React, { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import { Card, CardContent } from "../components/card";
import { Separator } from "../components/separator";
import { useUserCapability } from "../components/ConstantReducerProvider";
import { BindPostAPI } from "../services/APIConnection";
import MainPopup from "../popup-containers/MainPopup";
import ModulePopup from "../popup-containers/ModulePopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import DashboardPopup from "../popup-containers/DashboardPopup";
import { Type } from "lucide-react";
import toast from "react-hot-toast";

const DashboardCard = ({
  id,
  Type,
  title,
  description,
  value,
  titleStyle,
  descriptionStyle,
  valueStyle,
  cardStyle,
  onClick,
}) => (
  <Card className={cardStyle} onClick={() => onClick(id, Type)}>
    <CardContent>
      <h2 className={titleStyle}>{title}</h2>
      <p className={descriptionStyle}>{description}</p>
      <div className={valueStyle}>{value}</div>
    </CardContent>
  </Card>
);

const Dashboard = () => {
  debugger
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const partnerId = sessionStorage.getItem("partnerId");
  const [popUpTitle, setPopUpTitle] = useState("");
  const [popUpHeading, setPopUpHeading] = useState("");
  const [adminDashBoard, setAdminDashBoard] = useState([]);
  const [partnerDashBoard, setPartnerDashBoard] = useState([]);
  const [dashboardDatas, setDashBoardDatas] = useState([]);
  const [idValue, setIdValue] = useState([]);
  const [excelHeading, setExcelHeading] = useState([]);
  const [invitePartnerPopup, setInvitePartnerPopup] = useState(false);
  useEffect(() => {
    dashboardData();
  }, []);


  const handleCardClick = async (value) => {
debugger

    setDashBoardDatas([]);
    if (value.title == "Onboarded Companies") {
      var id = 1
      setPopUpTitle(value.title);
      setPopUpHeading(value.description);
    } else if (value.title == "Assessments Done") {
      var id = 2
      setPopUpTitle(value.title);
      setPopUpHeading(value.description);
    }
    else if (value.title == "Awaiting Score Cards") {
      var id = 3
      setPopUpTitle(value.title);
      setPopUpHeading(value.description);
    }
    else if (value.title == "Value Chain Partners Yet To Pay") {
      var id = 4
      setPopUpTitle(value.title);
      setPopUpHeading(value.description);
    }
    else if (value.title == "Value Chain Partners Yet To Start") {
      var id = 5
      setPopUpTitle(value.title);
      setPopUpHeading(value.description);
    }
    else if (value.title == "Awaiting Review") {
      var id = 6
      setPopUpTitle(value.title);
      setPopUpHeading(value.description);

    } else if (value.title == "Invited Value Chain Partners") {
      var id = 7
      setPopUpTitle(value.title);
      setPopUpHeading(value.description);

    } else if (value.title == "Value Chain Partner Signed Up") {
      var id = 8
      setPopUpTitle(value.title);
      setPopUpHeading(value.description);

    } else if (value.title == "Value Chain Partners Yet To Submit Answer") {
      var id = 9
      setPopUpTitle(value.title);
      setPopUpHeading(value.description);

    }
    else {
      var Type = 0
    }

    const data = {
      Id: id,
      Type: 0,
    };

    const response = await BindPostAPI(data, "DashboardAPI/BindDashboardSplitUp");
    setExcelHeading(value.title);
    setIdValue(id);
    if (Type != 0) {
      if (response.data.Table.length != 0) {
        setDashBoardDatas(response.data.Table);
        setInvitePartnerPopup(true);
      } else {
        setDashBoardDatas([]);
        toast.error(`No ${value.title}`, {
          duration: 3000,
          position: "top-center",

        });
        setInvitePartnerPopup(false);
      }
    }
  };

  const dashboardData = async () => {
    
    if (partnerId == "null") {
      var PartnerID = 0;
    } else {
      var PartnerID = partnerId;
    }
    const data = {
      partner: PartnerID,
    };
    const response = await BindPostAPI(data, "DashboardAPI/BindDashBoard");
    setAdminDashBoard(response.data.Table);
    setPartnerDashBoard(response.data.Table1);
  };

  return (
    <MainLayout pageName={"1"}>
      <div className="p-6">
        <h1 className="text-2xl font-bold mb-4">Dashboard</h1>
        <Separator className="mb-6" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {(userProfileDatas[0]?.MstRoleId == 1 ||
            userProfileDatas[0]?.MstRoleId == 2 ||
            userProfileDatas[0]?.MstRoleId == 4
            ? adminDashBoard || []
            : partnerDashBoard || []
          ).map((metric, index) => (
            <DashboardCard
              key={index}
              {...metric}
              id={metric.Id}
              type={metric.Type}
              titleStyle="text-2xl text-black font-semibold mb-1 "
              descriptionStyle="text-base text-lime-200 mb-2"
              valueStyle="text-3xl font-bold text-slate-100"
              onClick={() => handleCardClick(metric)}
              cardStyle={`shadow-md rounded-2xl p-4 ${userProfileDatas[0]?.MstRoleId == 1 ||
                userProfileDatas[0]?.MstRoleId == 2 ||
                userProfileDatas[0]?.MstRoleId == 4
                ? "bg-green-600 cursor-pointer"
                : "bg-yellow-600"
                } border rounded-lg `}
            />
          ))}
        </div>
      </div>
      <MainPopup
        popUpOpen={invitePartnerPopup}
        setpopUpOpen={setInvitePartnerPopup}
      >
        <div>
          <PopUpScreenTitle
            title={popUpTitle}
            sideHeader={popUpHeading}
            setpopUpOpen={setInvitePartnerPopup}
            hederDetails={true}
          />
          <DashboardPopup data={dashboardDatas} id={idValue} excelHeading={excelHeading} />
        </div>

      </MainPopup>
    </MainLayout>
  );
};

export default Dashboard;
